import React from 'react';
import { Link } from 'react-router-dom';
import {
  FaTrophy,
  FaUsers,
  FaCalendarCheck,
  FaMedal,
  FaArrowRight,
  FaStar,
  FaQuoteLeft,
  FaCheckCircle,
  FaPlay
} from 'react-icons/fa';
import './Home.css';

const Home = () => {
  const stats = [
    { icon: <FaTrophy />, number: '500+', label: 'Championships Won' },
    { icon: <FaUsers />, number: '2000+', label: 'Students Trained' },
    { icon: <FaCalendarCheck />, number: '15+', label: 'Years Experience' },
    { icon: <FaMedal />, number: '50+', label: 'National Players' },
  ];

  const services = [
    {
      // icon: '🏸',
      title: 'Professional Badminton Coaching',
      description: 'Our professional coaching service is led by experienced and qualified badminton coaches who focus on correct techniques, footwork, shot accuracy, and match strategies. Each training session is structured to ensure steady improvement, skill refinement, and performance consistency for players of all levels.',
      features: [],
      link: '/services/coaching-programs'
    },
    {
      title: 'Beginner Training Program',
      description: 'This program is specially designed for players who are new to badminton. It focuses on building strong fundamentals such as grip, basic strokes, foot movement, court awareness, and rules of the game. The training is conducted in a friendly and encouraging environment to build confidence and interest in the sport.',
      features: [],
      link: '/services/coaching-programs'
    },
    {
      title: 'Intermediate Skill Development Program',
      description: 'For players with basic badminton knowledge, this service helps improve technical skills and gameplay understanding. Training includes advanced strokes, better footwork coordination, speed enhancement, and tactical drills to prepare players for competitive play.',
      features: [],
      link: '/services/coaching-programs'
    },
    {
      title: 'Advanced & Competitive Training',
      description: 'Our advanced training service is designed for serious and tournament-level players. It includes high-intensity drills, match simulations, advanced strategies, and performance analysis. Players are trained to compete confidently in district, state, and higher-level tournaments.',
      features: [],
      link: '/services/coaching-programs'
    },
    {
      title: 'Private & One-to-One Coaching',
      description: 'This personalized coaching service offers individual attention tailored to a player’s specific needs and goals. Private sessions focus on correcting weaknesses, improving techniques, and accelerating performance improvement through customized training plans.',
      features: [],
      link: '/services/coaching-programs'
    },
    {
      title: 'Fitness & Physical Conditioning',
      description: 'Badminton demands speed, agility, stamina, and strength. Our fitness training service includes strength conditioning, endurance training, agility drills, flexibility exercises, and injury prevention routines. This service helps players improve overall athletic performance and reduce injury risks.',
      features: [],
      link: '/services/membership'
    },
  ];

  const whyChooseUs = [
    { icon: <FaCheckCircle />, text: 'Certified & Experienced Coaches' },
    { icon: <FaCheckCircle />, text: 'State-of-the-Art Facilities' },
    { icon: <FaCheckCircle />, text: 'Personalized Training Programs' },
    { icon: <FaCheckCircle />, text: 'Flexible Timing Options' },
    { icon: <FaCheckCircle />, text: 'Proven Track Record' },
    { icon: <FaCheckCircle />, text: 'Competitive & Supportive Environment' },
  ];

  const testimonials = [
    {
      name: 'Rahul Verma',
      role: 'Competitive Player',
      image: 'https://randomuser.me/api/portraits/women/44.jpg',
      rating: 5,
      content: 'Imperial Badminton Academy transformed my game completely. The coaches here are incredibly knowledgeable and supportive. I went from a district level player to representing my state in just two years! The personalized attention and scientific training methods made all the difference.',
    },
    {
      name: 'Ankit Sharma',
      role: 'State-Level Player',
      rating: 5,
      content: 'The structured training system here is outstanding. Every session is well planned, and the coaches give individual feedback that really helps improve weaknesses. Imperial Badminton Academy is the best place for serious badminton players.',
    },
    {
      name: 'Neha Gupta',
      role: 'Parent',
      image: 'https://randomuser.me/api/portraits/women/68.jpg',
      rating: 5,
      content: 'My child has shown tremendous improvement in both skills and discipline since joining Imperial Badminton Academy. The coaches are supportive, professional, and very patient with young players. I highly recommend this academy to parents.',
    },
  ];

  const coaches = [
    {
      name: 'Coach Rajesh Kumar',
      role: 'Head Coach & Founder',
      image: 'https://randomuser.me/api/portraits/men/75.jpg',
      experience: '20+ years experience'
    },
    {
      name: 'Coach Meera Singh',
      role: 'Senior Coach - Doubles',
      image: 'https://randomuser.me/api/portraits/women/65.jpg',
      experience: '15+ years experience'
    },
    {
      name: 'Coach Arjun Reddy',
      role: 'Youth Development Coach',
      image: 'https://randomuser.me/api/portraits/men/45.jpg',
      experience: '12+ years experience'
    },
    {
      name: 'Coach Sunita Devi',
      role: 'Fitness & Conditioning',
      image: 'https://randomuser.me/api/portraits/women/55.jpg',
      experience: '10+ years experience'
    },
  ];

  return (
    <div className="home">
      {/* Hero Section */}
      <section className="hero">
        <div className="hero-background">
          <div className="hero-overlay"></div>
        </div>
        <div className="container">
          <div className="hero-content">
            <span className="hero-badge">Welcome to Imperial Badminton Academy</span>
            <h1>Master the Art of <span>Badminton</span></h1>
            <p>
              Join the most prestigious badminton academy in the region. With world-class coaching,
              state-of-the-art facilities, and a proven track record of producing champions,
              we're here to help you achieve your badminton dreams.
            </p>
            <div className="hero-buttons">
              <Link to="/contact" className="btn btn-accent">
                Join Now <FaArrowRight />
              </Link>
              <Link to="/about" className="btn btn-secondary hero-secondary">
                Learn More
              </Link>
            </div>
            <div className="hero-features">
              <div className="hero-feature">
                <FaCheckCircle />
                <span>Expert Coaches</span>
              </div>
              <div className="hero-feature">
                <FaCheckCircle />
                <span>Modern Courts</span>
              </div>
              <div className="hero-feature">
                <FaCheckCircle />
                <span>All Age Groups</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section className="stats-section">
        <div className="container">
          <div className="stats-grid">
            {stats.map((stat, index) => (
              <div key={index} className="stat-card">
                <div className="stat-icon">{stat.icon}</div>
                <h3>{stat.number}</h3>
                <p>{stat.label}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* About Preview Section */}
      <section className="about-preview section">
        <div className="container">
          <div className="about-preview-grid">
            <div className="about-preview-images">
              <div className="about-img-main">
                <img src="https://images.unsplash.com/photo-1626224583764-f87db24ac4ea?w=600" alt="Badminton Training" />
              </div>
              <div className="about-img-secondary">
                <img src="https://images.unsplash.com/photo-1599391398131-cd12dfc6c24e?w=400" alt="Badminton Court" />
              </div>
              <div className="about-experience-badge">
                <span className="number">15+</span>
                <span className="text">Years of Excellence</span>
              </div>
            </div>
            <div className="about-preview-content">
              <span className="section-subtitle">About Our Academy</span>
              <h2>Welcome to Imperial Badminton Academy</h2>
              <p className="lead">
                Imperial Badminton Academy is more than just a training facility - we are a community
                of passionate badminton enthusiasts dedicated to developing champions both on and off the court.
              </p>
              <p>
                Imperial Badminton Academy is a dedicated center of excellence committed to the growth, development, and success of badminton players at every level. Established with the vision of creating disciplined athletes and future champions, our academy stands as a symbol of quality coaching, modern training methods, and a passion for the sport.
              </p>
              <p>
                At Imperial Badminton Academy, we believe badminton is more than just a game—it is a powerful tool for building character, confidence, physical fitness, and mental strength. Our goal is to provide a professional, structured, and motivating environment where players can learn, train, and evolve into complete athletes.
              </p>
              <ul className="about-features">
                {whyChooseUs.slice(0, 4).map((item, index) => (
                  <li key={index}>
                    {item.icon}
                    <span>{item.text}</span>
                  </li>
                ))}
              </ul>
              <Link to="/about" className="btn btn-primary">
                Discover More <FaArrowRight />
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section className="services-section section bg-light">
        <div className="container">
          <div className="section-title">
            <span className="section-subtitle">What We Offer</span>
            <h2>Our Programs & Services</h2>
            <p>
              Comprehensive training programs designed for all skill levels,
              from beginners taking their first steps to professionals aiming for glory.
            </p>
          </div>
          <div className="services-grid">
            {services.map((service, index) => (
              <div key={index} className="service-card">
                <div className="service-icon">{service.icon}</div>
                <h3>{service.title}</h3>
                <p>{service.description}</p>
                <Link to={service.link} className="service-link">
                  Learn More <FaArrowRight />
                </Link>
              </div>
            ))}
          </div>
          <div className="text-center mt-4">
            <Link to="/services" className="btn btn-primary">
              View All Services <FaArrowRight />
            </Link>
          </div>
        </div>
      </section>

      {/* Why Choose Us Section */}
      <section className="why-choose-section section">
        <div className="container">
          <div className="why-choose-grid">
            <div className="why-choose-content">
              <span className="section-subtitle">Why Choose Us</span>
              <h2>The Imperial Advantage</h2>
              <p>
                Choosing the right academy is crucial for your badminton journey. Here's why
                Imperial Badminton Academy stands out as the preferred choice for aspiring players.
              </p>
              <ul className="why-choose-list">
                {whyChooseUs.map((item, index) => (
                  <li key={index}>
                    {item.icon}
                    <span>{item.text}</span>
                  </li>
                ))}
              </ul>
              <Link to="/about/why-choose-us" className="btn btn-primary">
                Learn More <FaArrowRight />
              </Link>
            </div>
            <div className="why-choose-image">
              <img src="/img/about.jpg" alt="Badminton Training Session" />
              <div className="floating-card">
                <div className="floating-card-icon">
                  <FaTrophy />
                </div>
                <div className="floating-card-content">
                  <h4>Award Winning</h4>
                  <p>Best Academy 2023</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Testimonials Section */}
      <section className="testimonials-section section">
        <div className="container">
          <div className="section-title">
            <h2>What Our Students Say</h2>
            <p>
              Don't just take our word for it. Here's what our students and their
              parents have to say about their experience at Imperial Badminton Academy.
            </p>
          </div>
          <div className="testimonials-grid">
            {testimonials.map((testimonial, index) => (
              <div key={index} className="testimonial-card">
                <div className="testimonial-quote">
                  <FaQuoteLeft />
                </div>
                <p className="testimonial-content">{testimonial.content}</p>
                <div className="testimonial-rating">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <FaStar key={i} />
                  ))}
                </div>
                <div className="testimonial-author">
                  <div>
                    <h4>{testimonial.name}</h4>
                    <p>{testimonial.role}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
          <div className="text-center mt-4">
            <Link to="/testimonials" className="btn btn-primary">
              Read More Stories <FaArrowRight />
            </Link>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section">
        <div className="container">
          <div className="cta-content">
            <h2>Ready to Begin Your Badminton Journey?</h2>
            <p>
              Join Imperial Badminton Academy today and take the first step towards
              becoming a champion. Get a free trial session!
            </p>
            <div className="cta-buttons">
              <Link to="/contact" className="btn btn-accent">
                Enroll Now <FaArrowRight />
              </Link>
              <a href="tel:+919876543210" className="btn btn-secondary cta-secondary">
                Call Us: +91 97281 54227
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;
